 
import React, { memo } from "react";

const NotasDebito = () => {
  return <div>NotasDebito</div>;
};

export default memo(NotasDebito);
